import {
  type Country,
  type Currency,
  type FullDemandSignalDTO,
  type Incoterms,
  type MatchedSiteMaterialV2,
  useApiTransportPricesV1EstimateCreate,
} from 'api';
import { useCallback } from 'react';

export const useTransportCalculator = () => {
  const {
    mutateAsync: calculateTransportPrice,
    isPending: isTransportPriceLoading,
    error: transportPriceError,
    data: transportPrice,
  } = useApiTransportPricesV1EstimateCreate();

  const estimateTransportPrice = useCallback(
    async ({
      siteMaterial,
      supplyIncoterm,
      port,
      currency,
      demandSignal,
      demandIncoterm,
    }: {
      supplyIncoterm: Incoterms;
      demandIncoterm: Incoterms;
      port?: number;
      currency: Currency;
      siteMaterial: MatchedSiteMaterialV2;
      demandSignal: FullDemandSignalDTO;
    }) => {
      const originAddress = {
        country: siteMaterial.site.country as Country,
        full_address: siteMaterial.site.full_address,
        lat: Number.parseFloat(siteMaterial.site.latitude || '0'),
        lon: Number.parseFloat(siteMaterial.site.longitude || '0'),
      };
      const destinationAddress = demandSignal.buyer_sites?.[0] && {
        country: demandSignal.buyer_sites[0].country as Country,
        full_address: demandSignal.buyer_sites[0].full_address,
        lat: Number.parseFloat(demandSignal.buyer_sites[0].latitude || '0'),
        lon: Number.parseFloat(demandSignal.buyer_sites[0].longitude || '0'),
      };
      return calculateTransportPrice({
        data: {
          currency: currency,
          demand_incoterm: demandIncoterm,
          destination: destinationAddress,
          nearest_city_max_radius: '40',
          origin: originAddress,
          port_of_discharge: demandSignal.port_of_discharge?.id || undefined,
          port_of_loading: port,
          supply_incoterm: supplyIncoterm,
        },
      });
    },
    [calculateTransportPrice]
  );

  return {
    estimateTransportPrice,
    isLoading: isTransportPriceLoading,
    transportPrice,
    transportPriceError,
  };
};
